var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center align-content-center py-12"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.color,"size":"64"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }